/**
 * The buildings the signed-in user may see — GET /space/buildings, which
 * answers a site-scoped FM with only their own sites (FM Manager R1 A3).
 * One query key for the invite form, the edit dialog and Settings.
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet, unwrapList } from '@/utils/api';

export interface BuildingOption { id: string; name: string }

export function useBuildingOptions(enabled = true) {
  return useQuery<BuildingOption[]>({
    queryKey: ['site-scope', 'buildings'],
    enabled,
    staleTime: 60_000,
    queryFn: async () => unwrapList<BuildingOption>(await apiGet<unknown>('/space/buildings?page=1&limit=100')),
  });
}
